// Accordion customizations on top of Foundation's accordion
// currently on mobile single
import 'velocity-animate';

import $ from 'jquery';
import config from './globals/config';

export default function () {
  function init () {
    // only on mobile
    let singlePage = $('.single-film');

    if (singlePage.length > 0) {
      if (config.theWindow.width() <= 640) {
        initAccordion();

        registerEvents();

        closeContent();
      } else {
        disableAccordion();
      }
    } else {
      initAccordion();

      registerEvents();
    }
  }

  // set up initial heights, to mimic slideToggle
  function initAccordion () {
    $('.collapsible').each(function () {
      $(this).addClass('accordion-navigation');

      let content = $(this).find('.content.active');
      // reset height, for resizing
      content.css('height', 'auto');

      let height = content.height();

      content.attr('data-height', height).css({
        'opacity': 1,
        'height' : height,
        'display': 'block',
      });
    });
  }

  function disableAccordion () {
    $('.accordion a[role="tab"]').on('click', function (e) {
      e.preventDefault();
    });
  }

  function registerEvents () {
    // toggle click events
    $('.accordion li').on('click', 'a:eq(0)', function () {
      if ( $('.single.single-film').length && config.theWindow.width() > 640) {
        return;
      }

      let li = $(this).parent(),
        content = li.find('.content');

      if (li.hasClass('active') ) {
        content.velocity({ height: 0, opacity: 0 }, {
          duration: config.fastTiming,
          easing  : config.easing,
          display : 'none',
        });
      } else {
        content.velocity({ height: content.attr('data-height'), opacity: 1 }, {
          duration: config.fastTiming,
          easing  : config.easing,
          display : 'block',
        });
      }
    });

    // Throttled resize function
    $(window).on('resize', Foundation.utils.throttle(function () {
      initAccordion();
    }, 300));
  }

  function closeContent () {
    // close all but first
    $('.accordion a[role="tab"]:not(":first")').each(function () {
      $(this).trigger('click');
    });
  }

  init();
}
